const en = {
  common: {
    loading: 'Loading...',
    error: 'Error',
    provider_type: 'Provider Type',
    provider_type_all: 'All providers',
    provider_type_atlar: 'Atlar',
    provider_type_ebics: 'Ebics',
    provider_type_synthetic: 'Synthetic',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    create: 'Create',
    edit: 'Edit',
    close: 'Close',
    back: 'Back',
    search: 'Search',
    clear: 'Clear',
    confirm: 'Confirm',
    yes: 'Yes',
    no: 'No',
    ok: 'OK',
    copied: 'Copied',
    copy_to_clipboard: 'Copy to clipboard',
    show_more: 'Show more',
    show_less: 'Show less',
    just_now: 'just now',
    not_found: 'Not found',
    no_results: 'No results found',
    actions: 'Actions',
    details: 'Details',
    edit_details: 'Edit details',
    go_to_home: 'Go to home',
    refresh: 'Refresh',
    download: 'Download',
    sign_in: 'Sign in',
    forbidden: 'Access denied',
    forbidden_description:
      'You do not have permission to view this page. Please contact your administrator.',
    conflict: 'The data has changed. Please reload and try again.',
    too_many_requests: 'Too many requests',
    too_many_requests_description:
      'You sent too many requests in a short time, so the server is temporarily limiting them — this is not a problem with your data or anything you did wrong. Rate limits reset after a short time: please wait a moment, then refresh and try again.',
  },

  nav: {
    overview: 'Overview',
    dashboard: 'Dashboard',
    entities: 'Entities',
    managers: 'Managers',
    organisations: 'Organisations',
    property_owners: 'Property Owners',
    condominiums: 'Condominiums',
    rental_contracts: 'Rental Contracts',
    deposits: 'Deposits',
    operations: 'Operations',
    bulk_actions: 'Bulk Actions',
    unallocated_incoming_payments: 'Unallocated Incoming Payments',
    unallocated_outgoing_payments: 'Unallocated Outgoing Payments',
    manager_background_processes: 'Manager Background Processes',
    ebics: 'Ebics',
    unprovisioned_ebics_accounts: 'Unprovisioned Accounts',
    banking: 'Banking',
    accounts: 'Accounts',
    deposit_account_vibans: 'Deposit Account vIBANs',
    bank_account_viban_projections: 'Bank Account vIBANs',
    payment_files: 'Payment Files',
    bank_credit_transfers: 'Bank Credit Transfers',
    bank_direct_debits: 'Bank Direct Debits',
    bank_transactions: 'Bank Transactions',
    intraday_bank_transactions: 'Intraday Transactions',
    bank_account_statements: 'Bank Account Statements',
    deposit_guarantees: 'Deposit Guarantees',
    deposit_guarantee_applications: 'Deposit Guarantee Applications',
    claims: 'Claims',
    integrations: 'Integrations',
    vvrb_requests: 'VVRB Requests',
    vvrb_events: 'VVRB Events',
    everreal_events: 'EverReal Events',
    impower_events: 'impower Events',
    inactive_email_recipients: 'Inactive Email Recipients',
    administration: 'Administration',
    roles: 'Roles',
    users: 'Users',
    feature_toggles: 'Feature Toggles',
  },

  sidebar: {
    switch_to_light: 'Switch to light mode',
    switch_to_dark: 'Switch to dark mode',
    log_out: 'Log out',
    language: 'Language',
    account: 'Account',
    no_pages_available: 'No pages available',
    no_pages_available_description:
      'You do not have permissions to access any pages. Please contact your administrator.',
  },

  dashboard: {
    title: 'Dashboard',
    error_loading: 'Could not load dashboard.',
    summary: 'Summary',
    metric: {
      credit_transfers_failed_7d: 'Failed transfers (7d)',
      credit_transfers_in_flight: 'In-flight transfers',
      active_bank_accounts: 'Active bank accounts',
      total_balance: 'Total balance',
    },
    breakdown: {
      title: 'By account type',
      active_accounts_count: '{{count}} active accounts',
    },
  },

  account: {
    title: 'Account',
    error_loading: 'Could not load your account.',
    personal_information: 'Personal information',
    first_name: 'First name',
    last_name: 'Last name',
    email: 'Email',
    security: 'Security',
    passkey: {
      title: 'Passkey',
      no_passkey_description:
        'Set up a passkey to use as your second factor when signing in.',
      has_passkey_description:
        'A passkey is registered on your account. You can replace it at any time.',
      set_up_cta: 'Set up passkey',
      replace_cta: 'Replace passkey',
      success_set_up: 'Passkey set up successfully.',
      success_replaced: 'Passkey replaced successfully.',
      error_unsupported:
        'Your browser does not support passkeys. Try an up-to-date browser.',
      error_cancelled: 'Passkey setup was cancelled.',
      error_timeout: 'Passkey setup timed out. Please try again.',
      error_invalid_state:
        'This authenticator is already registered. Try a different one.',
      error_security: 'A security check failed during passkey setup.',
      error_generic: 'Could not set up the passkey. Please try again.',
    },
    mcp: {
      section: 'MCP',
      title: 'Backoffice MCP server',
      description:
        'The backoffice API is available to MCP clients over Streamable HTTP, using a personal API token. Tools are limited to the permissions of your account.',
      generate_cta: 'Generate token',
      regenerate_cta: 'Generate new token',
      token_once: 'Your new token — copy it now, it is not shown again',
      command_label: 'Add to Claude Code',
      success_generated: 'Token generated. The previous one is now revoked.',
      error_generating: 'Could not generate the token. Please try again.',
    },
  },

  passkey_prompt: {
    title: 'Set up your passkey',
    description:
      'Your account requires a passkey to continue. Set one up now to keep access to the backoffice.',
    set_up_cta: 'Set up passkey',
    back_to_login_cta: 'Back to login',
    success: 'Passkey set up successfully.',
    error_unsupported:
      'Your browser does not support passkeys. Try an up-to-date browser.',
    error_cancelled: 'Passkey setup was cancelled.',
    error_timeout: 'Passkey setup timed out. Please try again.',
    error_invalid_state:
      'This authenticator is already registered. Try a different one.',
    error_security: 'A security check failed during passkey setup.',
    error_generic: 'Could not set up the passkey. Please try again.',
    error_session_not_promoted:
      'Passkey was set up but signing in failed. Please try signing in again.',
  },

  passkey_challenge: {
    title: 'Verify your passkey',
    description:
      'Confirm it is you by approving the passkey prompt from your browser.',
    verify_cta: 'Verify passkey',
    back_to_login_cta: 'Back to login',
    success: 'Passkey verified.',
    error_unsupported:
      'Your browser does not support passkeys. Try an up-to-date browser.',
    error_cancelled: 'Passkey verification was cancelled.',
    error_timeout: 'Passkey verification timed out. Please try again.',
    error_invalid_state: 'This passkey cannot be used right now. Try another.',
    error_security: 'A security check failed during passkey verification.',
    error_generic: 'Could not verify the passkey. Please try again.',
    error_session_not_promoted:
      'Passkey was verified but signing in failed. Please try signing in again.',
  },

  auth: {
    not_signed_in: 'Not signed in',
    please_sign_in: 'Please sign in to continue',
    session_expired: 'Session expired',
    session_expired_description:
      'Your session has expired. Please sign in again to continue.',
    something_went_wrong: 'Something went wrong',
    invalid_credentials: 'Wrong E-Mail or Password',
    login_failed: 'Login failed',
    sign_in_title: 'Sign in to Getmomo',
    sign_in_description: 'Use your backoffice credentials to continue.',
    logging_out: 'Logging out...',
  },

  validation: {
    required: 'This field is required',
    invalid_email: 'Please enter a valid E-Mail address',
    invalid_url: 'Please enter a valid URL',
    too_short: 'This value is too short',
    too_long: 'This value is too long',
    invalid_number: 'Please enter a valid number',
    min_value: 'Value must be at least {{min}}',
    max_value: 'Value must be at most {{max}}',
    invalid_date: 'Please enter a valid date',
    invalid_iban: 'Please enter a valid IBAN',
    invalid_bic: 'Please enter a valid BIC',
    invalid_format: 'Invalid format',
    must_be_positive: 'Value must be positive',
    must_be_integer: 'Value must be a whole number',
    password_mismatch: 'Passwords do not match',
    server: {
      email_already_exists: 'A user with this email already exists',
      no_free_bank_account_iban:
        'No free IBAN is available. Please try again later.',
      bank_account_iban_taken: 'This IBAN is already taken. Please try again.',
    },
  },

  not_found: {
    title: 'Page not found',
    description:
      'The page you are looking for does not exist or has been moved.',
  },

  accounts: {
    title: 'Accounts',
    search_placeholder: 'e.g. IBAN, account name',
    create_account: 'Create Account',
    seed_load_failed:
      'Could not load the account to prefill from. Close and try again.',
    owner_belongs_to_other_manager: 'The owner belongs to a different manager.',
    error_loading: 'Error loading accounts',
    no_accounts: 'No accounts found',
    type: 'Type',
    account_name: 'Account name',
    iban: 'IBAN',
    iban_from_pool_placeholder: 'Leave empty to use the next free IBAN',
    bic: 'BIC',
    manager: 'Manager',
    bank: 'Bank',
    provider: 'Provider',
    status: 'Status',
    daily_closing_balance: 'Daily closing balance',
    created_at: 'Created at',
    all_types: 'All types',
    type_cash: 'Cash',
    type_rent: 'Rent',
    type_condo_fee: 'Condo Fee',
    type_condo_reserve: 'Condo Reserve',
    all_statuses: 'All statuses',
    status_draft: 'Draft',
    status_active: 'Active',
    status_closure_requested: 'Closure requested',
    status_closed: 'Closed',
    account_actions: 'Account actions',
    detail: {
      invalid: 'Invalid account.',
      not_found: 'Account not found. It may have been deleted.',
      server_error:
        'Could not load account details due to a server error. Please try again.',
      account: 'Account',
      id: 'ID',
      property_owner: 'Property owner',
      condominium: 'Condominium',
      external_fee_account_name: 'External Fee Account Name',
      external_fee_account_iban: 'External Fee Account IBAN',
      bank_external_reference: 'Bank External Reference',
      provider_type: 'Provider',
      effective_annual_interest_rate: 'Effective Annual Interest Rate',
      default: 'Default',
      is_default: 'Default',
      not_default: 'Not default',
      provider_account_url: 'Provider Account URL',
      provider_account_id: 'Provider Account ID',
      allocated_vibans: 'Allocated VIBANs',
      alias_vibans: 'Alias VIBANs',
      bank_transactions: 'Bank Transactions',
      view_bank_transactions: 'View bank transactions for this account',
      intraday_transactions: 'Intraday Transactions',
      view_intraday_transactions: 'View intraday transactions for this account',
      credit_transfers: 'Credit Transfers',
      view_credit_transfers: 'View credit transfers for this account',
      bank_account_vibans: 'Bank Account VIBANs',
      view_bank_account_vibans: 'View bank account VIBANs for this account',
      dates: 'Dates',
      updated_at: 'Updated At',
      closed_at: 'Closed At',
      delete_confirm:
        'Delete bank account "{{name}}"? Only DRAFT accounts can be deleted. This cannot be undone.',
      deleted: 'Bank account was deleted.',
      error_deleting: 'Error deleting bank account',
      delete_account: 'Delete account',
      closed_alert_title: 'Account is closed',
      closed_alert_message:
        'This account has been closed and can no longer be edited.',
      unpaid_interest_files: {
        generate: 'Generate unpaid interest files',
        generating: 'Generating unpaid interest files…',
        downloaded: 'Unpaid interest files downloaded.',
        failed: 'The unpaid interest files could not be generated.',
        forbidden:
          'You do not have permission to generate unpaid interest files.',
        no_unpaid_interest:
          'There is no unpaid interest for this account in the closure quarter.',
        tenant_viban_not_found:
          'Rental contract {{rentalContractId}} has no vIBAN on this account.',
        closure_request_not_found:
          'No closure request was found for this account.',
        unsupported_account:
          'Only HCOB and TEN31 deposit accounts in "Closure requested" are supported. Reload the page.',
        negative_unpaid_interest:
          'The unpaid interest is negative. Contact engineering.',
        settlement_mismatch:
          'The unpaid interest does not match the ledger balance. Contact engineering.',
        unprocessable_ledger_data:
          'The ledger data cannot be processed automatically. Contact engineering.',
        missing_data:
          'Data needed for the files is missing. Contact engineering.',
      },
      closure_requested_confirm:
        'Updating the account status to "Closure Requested" is an IRREVERSIBLE action. Are you sure?\n\nThis is permanent and can only be undone with a support ticket. A "Closure Requested" status indicates that our customer has requested to close the bank account.\n\nOnce the status is updated, any associated virtual accounts will no longer accrue additional interest.',
    },
  },

  organisations: {
    title: 'Organisations',
    search_placeholder: 'e.g. InWest Immobilien',
    error_loading: 'Error loading organisations',
    no_organisations: 'No organisations found',
    create_organisation: 'Create Organisation',
    creating: 'Creating',
    edit_organisation: 'Edit Organisation',
    updating: 'Updating',
    create: {
      description: 'Add a new organisation.',
      success: 'Organisation created',
      error: 'Organisation could not be created',
    },
    edit: {
      description: 'Update the organisation name and account fees (in cents).',
      success: 'Organisation updated',
      error: 'Organisation could not be updated',
    },
    fees: {
      title: 'Monthly account fees (in cents)',
      deposit: 'Deposit (cents)',
      rent: 'Rent (cents)',
      condominium_fee: 'Condominium fee (cents)',
      condominium_reserve: 'Condominium reserve (cents)',
      invalid: 'Please enter a whole amount in cents, e.g. 750',
    },
    columns: {
      name: 'Name',
      status: 'Status',
      managers: 'Managers',
      created_at: 'Created at',
    },
    status: {
      active: 'Active',
      closed: 'Closed',
    },
    detail: {
      invalid: 'Invalid organisation.',
      loading: 'Loading organisation...',
      not_found: 'Organisation not found.',
      organisation: 'Organisation',
      organisation_actions: 'Organisation actions',
      id: 'ID',
      name: 'Name',
      status: 'Status',
      close_organisation: 'Close organisation',
      reactivate_organisation: 'Reactivate organisation',
      close_dialog: {
        title: 'Close organisation',
        description:
          'Close {{organisationName}}? Its managers can no longer log in or use the API and integrations. Bookkeeping, statements and bank data keep running. You can reactivate it later.',
        confirm: 'Close',
        closing: 'Closing…',
      },
      closed_success: 'Organisation closed',
      closed_error: 'Organisation could not be closed',
      reactivated_success: 'Organisation reactivated',
      reactivated_error: 'Organisation could not be reactivated',
      managers: 'Managers',
      view_managers: 'View managers for this organisation ({{count}})',
      users: 'Users',
      view_users: 'View users',
      merge_organisation: 'Merge into organisation',
      merge_dialog: {
        title: 'Merge into organisation',
        description:
          'Move {{organisationName}} with all its managers and users into an existing organisation. Users of both organisations get access to all managers in the organisation.',
        target_organisation: 'Target organisation',
        merge: 'Merge',
        merging: 'Merging…',
      },
      merged_into_organisation:
        'Organisation was merged into the target organisation.',
      error_merging: 'Error merging organisation',
    },
  },

  managers: {
    title: 'Managers',
    search_placeholder: 'e.g. John Smith, john@...',
    create_manager: 'Create Manager',
    error_loading: 'Error loading managers',
    no_managers: 'No managers found',
    detail: {
      invalid: 'Invalid manager.',
      loading: 'Loading manager...',
      not_found: 'Manager not found.',
      manager_actions: 'Manager actions',
      login_as_manager: 'Login as Manager',
      edit_primary_user: 'Edit primary user',
      reset_password: 'Reset Password',
      send_onboarding_email: 'Send onboarding E-Mail',
      delete_confirm:
        'Do you want to delete {{name}}? This action is permanent.',
      deleted: 'Manager was deleted.',
      error_deleting: 'Error deleting manager',
      password_reset_sent: 'Password reset E-Mail was sent.',
      error_resetting_password: 'Error resetting password',
      onboarding_email_sent: 'Manager onboarding E-Mail sent.',
      error_sending_onboarding: 'Error sending onboarding E-Mail',
      identity: 'Identity',
      id: 'ID',
      user_id: 'User ID',
      type: 'Type',
      display_name: 'Display name',
      organisation: 'Organisation',
      first_name: 'First name',
      last_name: 'Last name',
      email: 'E-Mail',
      email_verified_at: 'E-Mail verified at',
      first_login_at: 'First login at',
      password_set: 'Password set',
      company: 'Company',
      company_name: 'Company name',
      tax_id: 'Tax ID',
      sales_tax_id: 'Sales tax ID',
      company_founded_date: 'Company founded date',
      framework_agreement_signed: 'Framework agreement signed',
      address: 'Address',
      street: 'Street',
      postal_code: 'Postal code',
      region: 'Region',
      country: 'Country',
      other: 'Other',
      phone: 'Phone',
      gender: 'Gender',
      date_of_birth: 'Date of birth',
      created_at: 'Created at',
      pending_legal_consents: 'Pending Legal Consents',
      user_consents: 'User Consents',
      all_consents_accepted: 'All terms and conditions accepted',
      consent_document: 'Document',
      consent_version: 'Version',
      consent_service: 'Service',
      consent_description: 'Description',
      service_type_GENERAL: 'General',
      service_type_DEPOSIT: 'Deposit',
      service_type_RENT: 'Rent',
      service_type_CONDOMINIUM: 'Condominium',
      service_type_PRICE_LIST: 'Price List',
    },
  },

  deposits: {
    title: 'Deposits',
    search_placeholder: 'e.g. tenant name, account',
    error_loading: 'Error loading deposits',
    no_deposits: 'No deposits found',
    manager: 'Manager',
    tenant_name: 'Tenant name',
    deposit_guarantee_application: 'Deposit guarantee application',
    deposit: 'Deposit',
    guarantee_active: 'Guarantee Active',
    deleted: 'Deleted',
    deleted_filter: 'Deletion status',
    deleted_filter_all: 'All',
    deleted_filter_deleted: 'Deleted',
    created_at: 'Created at',
    detail: {
      invalid: 'Invalid deposit.',
      loading: 'Loading deposit...',
      not_found: 'Deposit not found.',
      deposit: 'Deposit',
      status_manager_app: 'Status (Manager app)',
      status: 'Status',
      sub_status: 'Sub-status',
      main: 'Main',
      id: 'ID',
      rental_contract: 'Rental contract',
      manager: 'Manager',
      tenant_name: 'Tenant name',
      deposit_type: 'Deposit type',
      deleted_at: 'Deleted at',
      address_property: 'Address & property',
      postal_code: 'Postal code',
      region: 'Region',
      property_type: 'Property type',
      storey: 'Storey',
      street_name: 'Street name',
      street_number: 'Street number',
      tenant_phone_number: 'Tenant phone number',
      property_owner: 'Property owner',
      financial_dates: 'Financial & dates',
      cold_rent: 'Cold rent',
      deposit_amount: 'Deposit',
      start_date: 'Start date',
      created_at: 'Created at',
      deposit_released_at: 'Deposit released at',
      move_out_date: 'Move out date',
      other: 'Other',
      given_reference: 'Given reference',
      notes: 'Notes',
      restore: 'Restore deposit',
      restore_confirm:
        'Restore this deleted deposit and its rental contract? They will become active again.',
      restored: 'Deposit restored',
      error_restoring: 'Error restoring deposit',
      sub_status_values: {
        released: 'Released',
        released_with_remaining: 'Released, remaining amount {{amount}}',
        outgoing_transactions: 'Outgoing transactions available',
        rejected_by_tenant: 'Rejected by tenant',
      },
    },
  },

  claims: {
    title: 'Claims',
    search_placeholder: 'e.g. claim ID, manager',
    error_loading: 'Error loading claims',
    no_claims: 'No claims found',
    deposit: 'Deposit',
    manager: 'Manager',
    deposit_guarantee_application: 'Deposit guarantee application',
    amount: 'Amount',
    closed: 'Closed',
    created: 'Created',
    detail: {
      id: 'ID',
      rental_contract: 'Rental Contract',
      manager: 'Manager',
      deposit_guarantee_application: 'Deposit Guarantee Application',
      amount: 'Amount',
      bank_account_iban: 'Bank Account IBAN',
      bank_account_name: 'Bank Account Name',
      comment: 'Comment',
      closed: 'Closed',
      created: 'Created',
      close_claim: 'Close claim',
      reopen_claim: 'Reopen claim',
      delete_confirm: 'Are you sure you want to delete this claim?',
      closed_success: 'Claim closed',
      reopened_success: 'Claim reopened',
      deleted_success: 'Claim deleted',
    },
  },

  unallocated_incoming_payments: {
    iban: 'Account IBAN (optional)',
    error_deposit_account_not_found:
      'A deposit account for an unallocated payment was not found.',
  },

  unprovisioned_ebics_accounts: {
    iban: 'IBAN',
    name: 'Name',
    currency: 'Currency',
    servicer_bic: 'Servicer BIC',
    created: 'Created',
    provision: 'Provision Account',
    search_placeholder: 'Search by IBAN, name, BIC…',
    provision_success: 'Account provisioned',
    redirect_create:
      'No momo bank account exists for this IBAN yet — create it to finish provisioning.',
    ebics_account_not_found: 'This account no longer exists in ebics-service.',
    provision_failed: 'Could not provision the account',
  },

  unallocated_outgoing_payments: {
    reason: 'Reason',
    reason_batched: 'Batched by the bank ({{count}} payments)',
    allocate: {
      title: 'Allocate payment',
      loading: 'Allocating',
      virtual_account_iban: 'Virtual account IBAN',
      success: 'Payment allocated successfully',
      error: 'Allocation failed',
      already_allocated:
        'This payment has already been allocated. The list has been refreshed.',
      batched:
        'This payment cannot be allocated: the bank batched {{count}} payments into one booking, and an allocation always books the full amount to one account.',
      negative_title:
        'Virtual account will go negative: Are you sure you want to continue?',
      negative_description:
        'The payment amount exceeds the current virtual account balance. This will result in a negative balance.',
      confirm_negative: "Yes, let's go negative",
      viban_metadata: {
        tenant_name: 'Tenant',
        given_reference: 'Given reference',
        current_balance: 'Current balance',
      },
    },
    detail: {
      allocate_payment: 'Allocate payment',
      transaction_id: 'Transaction ID',
      bank_account_id: 'Bank Account ID',
      provider_type: 'Provider Type',
      counterparty_bic: 'Counterparty BIC',
      booking_date: 'Booking Date',
      value_date: 'Value Date',
      reference: 'Reference',
      mandate_reference: 'Mandate Reference',
      viban: 'VIBAN',
      end_to_end_id: 'End-to-End ID',
      return_reason: 'Return Reason',
      allocated: 'Allocated',
      returned: 'Returned',
      backfilled: 'Backfilled',
    },
  },

  bank_credit_transfers: {
    title: 'Bank Credit Transfers',
    all_statuses: 'All statuses',
    statuses: {
      CREATED: 'Created',
      SUBMITTED_TO_PROVIDER: 'Submitted to provider',
      REJECTED: 'Rejected',
      SENT: 'Sent',
      ACCEPTED: 'Accepted',
      EXECUTED: 'Executed',
      FAILED: 'Failed',
      RETURNED: 'Returned',
      UNKNOWN: 'Unknown',
    },
    search_placeholder: 'e.g. reference, IBAN',
    no_transfers: 'No bank credit transfers found',
    error_loading: 'Error loading bank credit transfers',
    id: 'ID',
    status: 'Status',
    counterparty_name: 'Counterparty Name',
    counterparty_iban: 'Counterparty IBAN',
    amount: 'Amount',
    remittance: 'Remittance',
    manager_id: 'Manager ID',
    deposit: 'Deposit',
    created: 'Created',
    date: 'Date',
    requested_execution_date: 'Execution Date',
    detail: {
      title: 'Bank Credit Transfer {{id}}',
      invalid: 'Invalid transfer. Please select a transfer from the list.',
      loading: 'Loading...',
      not_found: 'Transfer not found. It may have been deleted.',
      details: 'Details',
      id: 'ID',
      status: 'Status',
      status_reason_code: 'Status Reason Code',
      counterparty_name: 'Counterparty Name',
      counterparty_iban: 'Counterparty IBAN',
      amount: 'Amount',
      remittance_information: 'Remittance Information',
      manager: 'Manager',
      deposit_id: 'Deposit ID',
      bank_account_id: 'Bank Account ID',
      idempotency_key: 'Idempotency Key',
      external_id: 'External ID',
      external_type: 'External Type',
      batch_id: 'Batch ID',
      is_backfilled: 'Is Backfilled',
      external: 'External',
      open: 'Open',
      dates: 'Dates',
      created_at: 'Created At',
      updated_at: 'Updated At',
      submitted_to_provider_at: 'Submitted To Provider At',
      rejected_at: 'Rejected At',
      sent_at: 'Sent At',
      accepted_at: 'Accepted At',
      executed_at: 'Executed At',
      failed_at: 'Failed At',
      returned_at: 'Returned At',
      requested_execution_date: 'Requested Execution Date',
    },
  },

  bank_direct_debits: {
    title: 'Bank Direct Debits',
    all_statuses: 'All statuses',
    statuses: {
      CREATED: 'Created',
      SUBMITTED_TO_PROVIDER: 'Submitted to provider',
      REJECTED: 'Rejected',
      SENT: 'Sent',
      ACCEPTED: 'Accepted',
      EXECUTED: 'Executed',
      FAILED: 'Failed',
      RETURNED: 'Returned',
      UNKNOWN: 'Unknown',
    },
    search_placeholder: 'e.g. mandate, reference, manager ID',
    no_transfers: 'No bank direct debits found',
    error_loading: 'Error loading bank direct debits',
    id: 'ID',
    status: 'Status',
    counterparty_name: 'Debtor Name',
    counterparty_iban: 'Debtor IBAN',
    amount: 'Amount',
    mandate_id: 'Mandate ID',
    sequence_type: 'Sequence',
    manager_id: 'Manager ID',
    requested_collection_date: 'Collection Date',
    detail: {
      title: 'Bank Direct Debit {{id}}',
      invalid:
        'Invalid direct debit. Please select a direct debit from the list.',
      loading: 'Loading...',
      not_found: 'Direct debit not found. It may have been deleted.',
      details: 'Details',
      id: 'ID',
      status: 'Status',
      status_reason_code: 'Status Reason Code',
      status_reason_code_message: 'Status Reason Message',
      counterparty_name: 'Debtor Name',
      counterparty_iban: 'Debtor IBAN',
      amount: 'Amount',
      remittance_information: 'Remittance Information',
      manager: 'Manager',
      deposit_id: 'Reference ID',
      bank_account_id: 'Bank Account ID',
      idempotency_key: 'Idempotency Key',
      external_id: 'External ID',
      external_type: 'External Type',
      batch_id: 'Batch ID',
      mandate: 'Mandate',
      mandate_id: 'Mandate ID',
      mandate_signature_date: 'Mandate Signature Date',
      sequence_type: 'Sequence Type',
      creditor_scheme_id: 'Creditor Scheme ID (Gläubiger-ID)',
      dates: 'Dates',
      created_at: 'Created At',
      updated_at: 'Updated At',
      submitted_to_provider_at: 'Submitted To Provider At',
      rejected_at: 'Rejected At',
      sent_at: 'Sent At',
      accepted_at: 'Accepted At',
      executed_at: 'Executed At',
      failed_at: 'Failed At',
      returned_at: 'Returned At',
      requested_collection_date: 'Requested Collection Date',
    },
  },

  bank_account_statements: {
    title: 'Bank Account Statements',
    search_placeholder: 'e.g. IBAN, reference ID, manager ID, object key',
    no_statements: 'No bank account statements found',
    error_loading: 'Error loading bank account statements',
    download: 'Download Statement',
    regenerate: 'Re-generate Statement',
    regenerate_scheduled: 'Statement re-generation scheduled',
    status: 'Status',
    status_description: 'Status Description',
    status_all: 'All Statuses',
    status_draft: 'Draft',
    status_in_progress: 'In Progress',
    status_processed: 'Processed',
    status_failed: 'Failed',
    reference_type: 'Reference Type',
    reference_type_all: 'All Reference Types',
    reference_type_bank_account: 'Bank Account',
    reference_type_bank_account_viban: 'Bank Account vIBAN',
    reference_id: 'Reference ID',
    iban: 'IBAN',
    value_date: 'Value Date',
    downloaded_at: 'Downloaded At',
    bucket_name: 'Bucket Name',
    object_key: 'Object Key',
    detail: {
      actions: 'Statement actions',
      invalid: 'Invalid statement. Please select a statement from the list.',
      details: 'Details',
      storage: 'Storage',
      timestamps: 'Timestamps',
      id: 'ID',
      version: 'Version',
      manager_id: 'Manager ID',
      created_at: 'Created At',
      updated_at: 'Updated At',
    },
  },

  intraday_bank_transactions: {
    title: 'Intraday Transactions',
    search_placeholder: 'e.g. counterparty, IBAN, remittance, reference',
    no_transactions: 'No intraday transactions right now',
    error_loading: 'Error loading intraday transactions',
    direction: 'Direction',
    direction_all: 'All directions',
    direction_incoming: 'Incoming',
    direction_outgoing: 'Outgoing',
    incoming: 'Incoming',
    outgoing: 'Outgoing',
    amount: 'Amount',
    counterparty_name: 'Counterparty Name',
    counterparty_iban: 'Counterparty IBAN',
    account_iban: 'Account IBAN',
    booking_date: 'Booking Date',
    captured_at: 'Captured At',
    remittance: 'Remittance',
    entry_reference: 'Entry Reference',
    matched_payment: 'Matched Payment',
    matched_ct: 'Credit Transfer',
    matched_dd: 'Direct Debit',
  },
  bank_transactions: {
    title: 'Bank Transactions',
    search_placeholder: 'e.g. reference, IBAN, vIBAN',
    no_transactions: 'No bank transactions found',
    error_loading: 'Error loading bank transactions',
    id: 'ID',
    is_allocated: 'Is Allocated',
    counterparty_name: 'Counterparty Name',
    counterparty_iban: 'Counterparty IBAN',
    amount: 'Amount',
    remittance: 'Remittance',
    bank_account_id: 'Bank Account ID',
    viban: 'vIBAN',
    value_date: 'Value Date',
    booking_date: 'Booking Date',
    create_bank_transaction: 'Create Bank Transaction',
    creating: 'Creating',
    create: {
      description:
        'Manually create a bank transaction on an existing bank account.',
      success: 'Bank transaction was created.',
      error: 'Error creating bank transaction',
      bank_account: 'Bank Account',
      provider_account_id: 'Provider Account ID',
      provider_entity_id: 'Provider Entity ID',
      amount_cents: 'Amount (cents)',
      counterparty_bic: 'Counterparty BIC',
      reference: 'Reference',
      mandate_reference: 'Mandate Reference',
      end_to_end_id: 'End-to-End ID',
      return_reason: 'Return Reason',
      is_returned: 'Is Returned',
      is_backfilled: 'Is Backfilled',
      is_externally_initiated: 'Is Externally Initiated',
      is_allocated: 'Is Allocated',
    },
    created: 'Created',
    updated: 'Updated',
    detail: {
      title: 'Bank Transaction {{id}}',
      invalid:
        'Invalid transaction. Please select a transaction from the list.',
      loading: 'Loading...',
      not_found: 'Transaction not found. It may have been deleted.',
      details: 'Details',
      provider: 'Provider',
      dates: 'Dates',
      id: 'ID',
      is_allocated: 'Is Allocated',
      counterparty_name: 'Counterparty Name',
      counterparty_iban: 'Counterparty IBAN',
      counterparty_bic: 'Counterparty BIC',
      amount: 'Amount',
      remittance_information: 'Remittance Information',
      bank_account_id: 'Bank Account ID',
      viban: 'vIBAN',
      reference: 'Reference',
      mandate_reference: 'Mandate Reference',
      end_to_end_id: 'End-to-End ID',
      return_reason: 'Return Reason',
      returned: 'Returned',
      backfilled: 'Backfilled',
      externally_initiated: 'Externally Initiated',
      batch_transaction_count: 'Batched Payments',
      provider_type: 'Provider Type',
      provider_account_id: 'Provider Account ID',
      provider_entity_id: 'Provider Entity ID',
      created_at: 'Created At',
      updated_at: 'Updated At',
      value_date: 'Value Date',
      booking_date: 'Booking Date',
    },
  },

  formance: {
    title: 'Formance Transactions',
    none: 'No Formance transactions found',
    error: 'Error loading Formance transactions',
    id: 'ID',
    amount: 'Amount',
    source: 'Source',
    destination: 'Destination',
    created_at: 'Created At',
  },

  property_owners: {
    title: 'Property Owners',
    search_placeholder: 'e.g. Max Müller',
    error_loading: 'Error loading property owners',
    no_property_owners: 'No property owners found',
    type_individual: 'Individual',
    type_company: 'Company',
    create_property_owner: 'Create Property Owner',
    create: {
      description: 'Create a property owner for a manager.',
      success: 'Property owner created',
      error: 'Could not create property owner',
    },
    edit: {
      description: 'Update the property owner details.',
      success: 'Property owner updated',
      error: 'Could not update property owner',
    },
    detail: {
      invalid: 'Invalid property owner.',
      loading: 'Loading property owner...',
      not_found: 'Property owner not found.',
      identity: 'Identity',
      id: 'ID',
      type: 'Type',
      company: 'Company',
      company_tax_id: 'Company Tax ID',
      phone: 'Phone',
      email: 'E-Mail',
      manager: 'Manager',
      created: 'Created',
      address: 'Address',
      street: 'Street',
      postal_code: 'Postal Code',
      region: 'Region',
      country: 'Country',
      bank: 'Bank',
      customer_reference: 'Customer Reference',
      owner_1: 'Owner 1',
      owner_2: 'Owner 2',
      director: 'Director',
      first_name: 'First Name',
      last_name: 'Last Name',
      date_of_birth: 'Date of Birth',
      tax_id: 'Tax ID',
    },
  },

  roles: {
    title: 'Roles',
    create_role: 'Create Role',
    search_placeholder: 'e.g. Admin',
    no_roles: 'No roles found',
    error_loading: 'Error loading roles',
    role: 'Role',
    description: 'Description',
    users: 'Users',
    permissions: 'Permissions',
    project: 'Project',
    invalid_role: 'Invalid role. Please select a role from the list.',
    loading_role: 'Loading role...',
    role_not_found: 'Role not found. It may have been deleted.',
    role_information: 'Role Information',
    name: 'Name',
    manage_permissions: 'Manage permissions',
    view_users_with_role: 'View users with this role',
    error_deleting_role: 'Failed to delete role',
    error_creating_role: 'Error creating role',
    create_role_description:
      'Add a new role with name, description and project type.',
    creating: 'Creating',
    role_updated: 'Role updated successfully',
    error_updating_role: 'Error updating role',
    edit_role: 'Edit Role',
    edit_role_description:
      'Update the role description. Role name and project cannot be changed.',
    permissions_drawer: {
      title: 'Permissions',
      description: 'Toggle permissions assigned to this role',
      search_placeholder: 'e.g. deposit, create',
      no_permissions: 'No permissions found',
      assigned: 'Assigned',
      not_assigned_only: 'Not assigned only',
    },
    delete_dialog: {
      title: 'Delete Role',
      description:
        'Are you sure you want to delete "{{roleName}}"? This action cannot be undone.',
      deleting: 'Deleting...',
    },
  },

  users: {
    title: 'Users',
    create_backoffice_user: 'Create Backoffice User',
    search_placeholder: 'e.g. john@momo.de',
    no_users: 'No users found',
    error_loading: 'Error loading users',
    all_roles: 'All roles',
    all_statuses: 'All statuses',
    user: 'User',
    passkey: {
      title: 'Passkey',
      status_label: 'Status',
      status_registered: 'Registered',
      status_not_registered: 'Not registered',
      registered_on_label: 'Registered on',
      reset_cta: 'Reset passkey',
      reset_disabled_hint: 'No passkey to reset',
      reset_success: 'Passkey reset',
      reset_error: 'Failed to reset passkey',
      reset_dialog: {
        title: 'Reset passkey for {{userName}}?',
        description:
          'This will delete their passkey. They will be required to register a new one on their next sign-in.',
        confirm_cta: 'Reset',
        resetting: 'Resetting...',
      },
    },
    invalid_user: 'Invalid user. Please select a user from the list.',
    loading_user: 'Loading user...',
    user_not_found: 'User not found. They may have been deleted.',
    user_information: 'User Information',
    full_name: 'Full name',
    last_login: 'Last login',
    joined: 'Joined',
    organisation: 'Organisation',
    manage_roles: 'Manage roles',
    backoffice_user_created: 'Backoffice user created',
    error_creating_backoffice_user: 'Error creating backoffice user',
    create_backoffice_user_description:
      'Add a new backoffice user with login credentials.',
    creating: 'Creating',
    first_name: 'First name',
    last_name: 'Last name',
    password: 'Password',
    backoffice_user_updated: 'Backoffice user updated',
    error_updating_backoffice_user: 'Error updating backoffice user',
    edit_backoffice_user: 'Edit Backoffice User',
    edit_backoffice_user_description:
      'Update name, E-Mail, or set a new password. Leave password empty to keep the current one.',
    user_updated: 'User updated',
    error_updating_user: 'Error updating user',
    edit_user: 'Edit User',
    edit_user_description: 'Update name or E-Mail.',
    saving: 'Saving',
    email_address: 'E-Mail address',
    password_hint: 'Password (min 12 characters, leave empty to keep)',
    roles_drawer: {
      title: 'Roles',
      description: 'Toggle roles assigned to this user',
      manager_description:
        'A manager user always has exactly one role. Choosing a role replaces the current one.',
      search_placeholder: 'e.g. Admin, Manager',
      no_roles: 'No roles found',
      assigned: 'Assigned',
    },
    delete_dialog: {
      title: 'Delete User',
      description:
        'Are you sure you want to delete "{{userName}}"? This action cannot be undone.',
      deleting: 'Deleting...',
    },
    error_deleting_user: 'Failed to delete user',
    set_primary_user: {
      action: 'Make primary user',
      title: 'Make primary user',
      description:
        'Make {{userName}} the primary user of a manager in their organisation. The manager’s current primary user is replaced.',
      manager: 'Manager',
      select_manager: 'Select manager…',
      search_manager: 'Search manager…',
      no_manager_found: 'No manager found.',
      confirm: 'Make primary user',
      saving: 'Saving…',
      success: 'Primary user updated',
      error: 'Error updating primary user',
      error_not_admin: 'User must have the Admin role to become primary user',
    },
  },

  bulk_actions: {
    virtual_deposit_accounts: 'Virtual Deposit Accounts',
    bulk_create_virtual_deposit_accounts:
      'Bulk create virtual deposit accounts',
    bulk_allocate_incoming_transfers: 'Bulk allocate incoming transfers',
    bulk_close_virtual_deposit_accounts: 'Bulk close virtual deposit accounts',
    accounts: 'Accounts',
    bulk_create_condominium_accounts: 'Bulk create condominium accounts',
    bulk_create_rent_accounts: 'Bulk create rent accounts',
    add_bank_account_ibans: 'Add IBANs to the condominium account IBAN pool',
    add_bank_account_ibans_with_free_count:
      'Add IBANs to the condominium account IBAN pool (free: {{free}})',
    download_template: 'Template',
    upload_success: 'Bulk Import CSV successfully uploaded',
    upload_failed: 'Upload failed',
    uploading: 'Uploading...',
    upload_csv: 'Upload CSV',
    validation_error: 'Validation error',
    csv_validation_description:
      'We found issues in your CSV. Please download the file below to review the problematic rows, fix them, and try again.',
    download_import_results: 'Download import results as CSV file',
    json_validation_file_prefix: 'The file',
    json_validation_file_suffix: 'contains invalid data.',
    json_validation_description_prefix:
      'Validation errors are displayed below. Paths start with',
    json_validation_description_suffix:
      'Add 2 to the row index to get the CSV line number. Please correct the errors and try again.',
  },

  rental_contracts: {
    title: 'Rental Contracts',
    search_placeholder: 'e.g. tenant name, address',
    error_loading: 'Error loading rental contracts',
    no_rental_contracts: 'No rental contracts found',
    detail: {
      invalid: 'Invalid rental contract.',
      loading: 'Loading rental contract...',
      not_found: 'Rental contract not found.',
      rental_contract: 'Rental Contract',
      id: 'ID',
      deposit: 'Deposit',
      manager: 'Manager',
      tenant: 'Tenant',
      tenant_name: 'Tenant name',
      tenant_phone: 'Tenant phone',
      source_id: 'Source ID',
      source_type: 'Source type',
      deposit_account_viban: 'Deposit account VIBAN',
      address: 'Address',
      postal_code: 'Postal code',
      region: 'Region',
      property_type: 'Property type',
      storey: 'Storey',
      street_name: 'Street name',
      street_number: 'Street number',
      property_owner: 'Property owner',
      property_owner_display_name: 'Property owner display name',
      financial: 'Financial',
      cold_rent: 'Cold rent',
      deposit_amount: 'Deposit amount',
      start_date: 'Start date',
      signed_date: 'Signed date',
      created: 'Created',
      given_reference: 'Given reference',
      notes: 'Notes',
    },
    edit: {
      title: 'Edit Rental Contract',
      description:
        'Update manager, property owner and origin. Other fields are read-only.',
      origin: 'Origin',
      success: 'Rental contract updated successfully',
      error: 'Error updating rental contract',
    },
  },

  bank_account_viban_projections: {
    allocated_at: 'Allocated',
    kind: 'Kind',
    alias: 'Alias',
    virtual_account: 'Virtual account',
    kind_all: 'All kinds',
    reference_type: 'Reference Type',
    reference: 'Reference',
    reference_type_property_owner: 'Property Owner',
    detail: {
      version: 'Version',
      reference_type: 'Reference Type',
      kind: 'Kind',
      onboarding_external_reference: 'Onboarding External Reference',
      balance: 'Balance',
      balance_updated_at: 'Balance Updated At',
    },
  },

  payment_files: {
    filename: 'File',
    status: 'Status',
    manager: 'Manager',
    type: 'Type',
    submitted_at: 'Submitted',
    search_placeholder: 'Search by manager or IBAN',
    all_statuses: 'All statuses',
    download: 'Download',
    statuses: {
      UPLOAD_PENDING: 'Upload pending',
      UPLOADED: 'Uploaded',
      VALIDATED: 'Validated',
      INVALID: 'Invalid',
      SUBMITTING: 'Submitting',
      SUBMITTED: 'Submitted',
      SUBMISSION_FAILED: 'Submission failed',
      SENT: 'Sent',
      PROCESSED: 'Processed',
      FAILED: 'Failed',
    },
    detail: {
      credit_transfers: 'Credit Transfers',
      view_credit_transfers: 'View credit transfers for this file',
      direct_debits: 'Direct Debits',
      view_direct_debits: 'View direct debits for this file',
      actions: 'Payment file actions',
      details: 'Details',
      dates: 'Dates',
      id: 'ID',
      version: 'Version',
      updated_at: 'Updated',
      sender_iban: 'Sender IBAN',
      bank_account_id: 'Bank account',
      transaction_count: 'Transactions',
      total_amount: 'Total amount',
      external_entity_id: 'Provider reference',
      validation_reason: 'Validation reason',
      failure_reason: 'Failure reason',
      invalid: 'Invalid payment file.',
      not_found: 'Payment file not found.',
    },
  },

  deposit_account_vibans: {
    detail: {
      viban: 'VIBAN',
      onboarding_external_reference: 'Onboarding External Reference',
      given_reference: 'Given Reference',
    },
    edit: {
      title: 'Edit VIBAN',
      description: 'Update the onboarding external reference for this VIBAN.',
      success: 'VIBAN updated successfully',
      error: 'Error updating VIBAN',
    },
    upload: {
      button: 'Upload VIBANs',
      success: 'VIBANs successfully uploaded',
      error: 'Failed to upload VIBANs',
      total_vibans: 'Total VIBANs',
    },
  },

  manager_background_processes: {
    source: 'Source',
    source_filter_all: 'All sources',
    source_filter_manager_app: 'Manager App',
    source_filter_public_api: 'Public API',
    detail: {
      id: 'ID',
      manager_id: 'Manager ID',
      source: 'Source',
      type: 'Type',
      version: 'Version',
      total_items: 'Total Items',
      completed_items: 'Completed Items',
      bucket_name: 'Bucket Name',
      artifact_filename: 'Artifact Filename',
      created: 'Created',
      completed: 'Completed',
      downloaded: 'Downloaded',
      parameters: 'Parameters',
    },
  },

  deposit_guarantee_applications: {
    detail: {
      main: 'Main',
      id: 'ID',
      provider: 'Provider',
      created_at: 'Created at',
      deposit: 'Deposit',
      rental_contract: 'Rental contract',
      tenant_name: 'Tenant name',
      tenant_email: 'Tenant E-Mail',
      tenant_phone: 'Tenant phone',
      warm_rent: 'Warm rent',
      tenant_iban: 'Tenant IBAN',
      manager: 'Manager',
      property_owner: 'Property owner',
      mock_schufa_score: '[test] Choose Schufa Score',
      provider_fields: 'Provider fields',
      fees_dates: 'Fees & dates',
      monthly_fee: 'Monthly fee',
      yearly_fee: 'Yearly fee',
      start_date: 'Start date',
      accepted_at: 'Accepted at',
      rejection: 'Rejection',
      rejected_at: 'Rejected at',
      rejected_by: 'Rejected by',
      reject_reason: 'Reject reason',
      reject_comment: 'Reject comment',
      contract_certificate: 'Contract / certificate',
      swk_contract: 'SWK contract',
      review_swk_contract: 'Review SWK contract',
      vvrb_certificate: 'VVRB certificate',
      open_certificate: 'Open certificate',
      upload_document: 'Upload document',
      income_proofs: 'Income proofs',
      residence_permits: 'Residence permits',
      city_registrations: 'City registrations',
      rental_contract_documents: 'Rental contract documents',
      tenant_application: 'Tenant application',
      filename: 'Filename',
      url: 'Url',
    },
    edit: {
      title: 'Edit deposit guarantee application',
      description: 'Update the tenant IBAN for this application.',
      success: 'Deposit guarantee application updated',
      error: 'Error updating deposit guarantee application',
    },
  },

  condominiums: {
    title: 'Condominiums',
    search_placeholder: 'e.g. Berliner Str. 12',
    create_condominium: 'Create Condominium',
    error_loading: 'Error loading condominiums',
    no_condominiums: 'No condominiums found',
    detail: {
      invalid: 'Invalid condominium.',
      loading: 'Loading condominium...',
      not_found: 'Condominium not found.',
      title: 'Title',
      legal_name: 'Legal Name',
      address: 'Address',
      kyc: 'KYC',
      number_of_owners: 'Number of owners',
      tax_resident_outside_germany: 'The WEG is tax resident outside Germany',
      is_pep:
        'Politically exposed persons are part of the business relationship',
      kyc_unanswered: 'Not answered',
    },
  },

  feature_toggles: {
    search_placeholder: 'e.g. ai_chat',
    error_loading: 'Error loading feature toggles',
    error_updating: 'Failed to update feature toggle',
    no_rows: 'No feature toggles found',
    toggle: 'Toggle',
    scope: 'Scope',
    limited: 'Limited',
    global: 'Global',
    enabled: 'Enabled',
    disabled: 'Disabled',
    managers: 'Managers',
    manager: 'Manager',
    scope_everyone: 'Everyone',
    scope_selected: 'Selected managers',
    add_manager: 'Add',
    remove_manager: 'Remove manager',
    no_managers: 'No managers selected, this toggle applies to nobody',
    invalid: 'Invalid feature toggle.',
    loading: 'Loading feature toggle...',
    not_found: 'Feature toggle not found.',
  },

  vvrb_requests: {
    search_placeholder: 'e.g. request ID',
    error_loading: 'Error loading VVRB requests',
    no_rows: 'No VVRB requests found',
    invalid: 'Invalid request.',
    loading: 'Loading request...',
    not_found: 'Request not found.',
    path: 'Path',
    process_id: 'VVRB Process ID',
    dga_id: 'DGA ID',
    duration: 'Duration',
    request: 'Request',
    response: 'Response',
  },

  vvrb_events: {
    search_placeholder: 'e.g. event type',
    error_loading: 'Error loading VVRB events',
    no_rows: 'No VVRB events found',
    invalid: 'Invalid event.',
    loading: 'Loading event...',
    not_found: 'Event not found.',
    payload: 'Payload',
  },

  everreal_events: {
    search_placeholder: 'e.g. event type, ID',
    error_loading: 'Error loading EverReal events',
    no_rows: 'No EverReal events found',
    invalid: 'Invalid event.',
    loading: 'Loading event...',
    not_found: 'Event not found.',
    payload: 'Payload',
  },

  inactive_email_recipients: {
    search_placeholder: 'e.g. email address',
    error_loading: 'Error loading inactive email recipients',
    no_rows: 'No inactive email recipients found',
    email: 'Email',
    template: 'Template',
    reason: 'Reason',
    last_failed_at: 'Last failed',
    reactivate: 'Reactivate',
    reactivate_success: 'Recipient reactivated',
    reactivate_failed: 'Could not reactivate the recipient',
  },

  impower_events: {
    search_placeholder: 'e.g. event type, ID',
    error_loading: 'Error loading impower events',
    no_rows: 'No impower events found',
    invalid: 'Invalid event.',
    loading: 'Loading event...',
    not_found: 'Event not found.',
    payload: 'Payload',
    manager: 'Manager',
  },

  languages: {
    en: 'English',
    de: 'Deutsch',
  },
} as const;

export default en;

export type TranslationKeys = typeof en;
